import React, { useState } from "react";
import { formatRut, getRutValidationMessage, isValidRut } from "../../Helper/Cotizacion/rutUtils";
import { siiService } from "../../Helper/Cotizacion/siiService.mock";

const ClientForm = ({ client, onChange }) => {
	const [rutError, setRutError] = useState("");
	const [siiMessage, setSiiMessage] = useState("");
	const [loadingMock, setLoadingMock] = useState(false);

	const handleField = (event) => {
		const { name, value } = event.target;
		if (name === "rut") {
			const formatted = formatRut(value);
			onChange({ ...client, rut: formatted });
			if (formatted) {
				setRutError(getRutValidationMessage(formatted));
			} else {
				setRutError("El RUT es obligatorio.");
			}
			return;
		}
		onChange({ ...client, [name]: value });
	};

	const handleConsultarSii = async () => {
		setSiiMessage("La consulta automática al SII estará disponible en una próxima etapa.");
		// La interfaz está preparada; siiService.consultarContribuyente no hace requests reales.
		await siiService.consultarContribuyente(client.rut);
	};

	const handleSimularSii = async () => {
		if (!client.rut || !isValidRut(client.rut)) {
			setRutError(getRutValidationMessage(client.rut));
			return;
		}
		setLoadingMock(true);
		try {
			// MOCK explícito: datos ficticios, no consulta real al SII.
			const data = await siiService.consultarContribuyenteMock(client.rut);
			if (data) {
				onChange({
					...client,
					nombre: data.nombre || client.nombre,
					giro: data.giro || client.giro,
					domicilio: data.domicilio || client.domicilio,
					comuna: data.comuna || client.comuna,
				});
				setSiiMessage(data.mensaje);
			}
		} finally {
			setLoadingMock(false);
		}
	};

	return (
		<section style={{ marginBottom: "24px" }}>
			<h5 style={{ marginBottom: "8px" }}>2. Datos del cliente</h5>
			<div className="grid-x grid-margin-x">
				<div className="cell small-12 medium-4">
					<label>
						RUT <span style={{ color: "#c53030" }}>*</span>
						<input
							type="text"
							name="rut"
							value={client.rut}
							onChange={handleField}
							placeholder="12.345.678-9"
						/>
					</label>
					{rutError ? (
						<small style={{ color: "#c53030" }}>{rutError}</small>
					) : null}
				</div>
				<div className="cell small-12 medium-8">
					<label>
						Nombre o razón social <span style={{ color: "#c53030" }}>*</span>
						<input
							type="text"
							name="nombre"
							value={client.nombre}
							onChange={handleField}
							placeholder="Empresa o persona"
						/>
					</label>
				</div>
				<div className="cell small-12 medium-4">
					<label>
						Correo
						<input
							type="email"
							name="correo"
							value={client.correo}
							onChange={handleField}
						/>
					</label>
				</div>
				<div className="cell small-12 medium-4">
					<label>
						Teléfono
						<input
							type="text"
							name="telefono"
							value={client.telefono}
							onChange={handleField}
						/>
					</label>
				</div>
				<div className="cell small-12 medium-4">
					<label>
						Giro
						<input type="text" name="giro" value={client.giro} onChange={handleField} />
					</label>
				</div>
				<div className="cell small-12 medium-8">
					<label>
						Domicilio
						<input
							type="text"
							name="domicilio"
							value={client.domicilio}
							onChange={handleField}
						/>
					</label>
				</div>
				<div className="cell small-12 medium-4">
					<label>
						Comuna
						<input
							type="text"
							name="comuna"
							value={client.comuna}
							onChange={handleField}
						/>
					</label>
				</div>
			</div>

			<div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginTop: "8px" }}>
				<button
					type="button"
					className="button secondary hollow"
					title="Próximamente"
					onClick={handleConsultarSii}
				>
					Consultar en el SII
				</button>
				<button
					type="button"
					className="button hollow"
					onClick={handleSimularSii}
					disabled={loadingMock}
				>
					{loadingMock ? "Consultando..." : "Simular consulta SII (mock)"}
				</button>
			</div>
			{siiMessage ? (
				<p style={{ marginTop: "8px", color: "#4a5568", fontSize: "13px" }}>{siiMessage}</p>
			) : (
				<p style={{ marginTop: "8px", color: "#718096", fontSize: "13px" }}>
					La consulta automática al SII estará disponible en una próxima etapa. Puedes
					completar los datos manualmente.
				</p>
			)}
		</section>
	);
};

export default ClientForm;
